import useComponentSize from "@rehooks/component-size";
import React, { useContext, useMemo, useRef, useEffect } from "react";
import { useTransition, animated as a } from "react-spring";
import AccordionContext from "../context";
import * as S from "./styles";
export var Child = function Child(_ref) {
  var e = _ref.children,
      o = _ref.className,
      t = _ref.style,
      _ref$uid = _ref.uid,
      n = _ref$uid === void 0 ? "" : _ref$uid,
      _ref$showBorderBottom = _ref.showBorderBottom,
      i = _ref$showBorderBottom === void 0 ? !1 : _ref$showBorderBottom,
      _ref$scrollOffset = _ref.scrollOffset,
      r = _ref$scrollOffset === void 0 ? 128 : _ref$scrollOffset;

  var _useContext = useContext(AccordionContext),
      s = _useContext.openedItems,
      c = _useContext.scrollToOpenedContent,
      d = useMemo(function () {
    return null == s ? void 0 : s.includes(n);
  }, [s, n]),
      l = useRef(null),
      m = useRef(null),
      f = useComponentSize(l),
      p = useTransition(d, {
    from: {
      opacity: 0,
      height: 0,
      overflow: "hidden"
    },
    enter: {
      opacity: 1,
      height: d ? f.height : 0
    },
    leave: {
      opacity: 0,
      height: 0
    }
  });

  return useEffect(function () {
    if ("undefined" != typeof window && d && m && c) {
      var _e = m.current;

      if (_e) {
        var _o = _e.getBoundingClientRect().top + window.pageYOffset;

        window.scroll({
          top: _o - r,
          behavior: "smooth"
        });
      }
    }
  }, [d, m, c]), React.createElement(S.ChildWrapper, {
    showBorderBottom: i,
    ref: m
  }, p(function (i) {
    return React.createElement(a.div, {
      style: i
    }, React.createElement(S.ContentWrapper, {
      ref: l,
      className: o,
      id: "accordion-child-" + n,
      "data-testid": "accordion-child-" + n,
      role: "region",
      style: t,
      "aria-labelledby": "accordion-heading-" + n,
      "aria-hidden": !d
    }, "function" == typeof e ? e(d) : e));
  }));
};
export default React.memo(Child);